var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShape = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.307617C4.47715 0.307617 0 4.78477 0 10.3076C0 15.8305 4.47715 20.3076 10 20.3076C15.5228 20.3076 20 15.8305 20 10.3076C20 7.65545 18.9464 5.11191 17.0711 3.23655C15.1957 1.36119 12.6522 0.307617 10 0.307617ZM11 14.3076C11 14.8599 10.5523 15.3076 10 15.3076C9.44771 15.3076 9 14.8599 9 14.3076V9.30762C9 8.75533 9.44771 8.30762 10 8.30762C10.5523 8.30762 11 8.75533 11 9.30762V14.3076ZM9 6.30762C9 6.8599 9.44771 7.30762 10 7.30762C10.5523 7.30762 11 6.8599 11 6.30762C11 5.75533 10.5523 5.30762 10 5.30762C9.44771 5.30762 9 5.75533 9 6.30762Z",
    fill: "#00B8D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShape);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shape.e6991c303c52b7cdc978cc3651fa175a.svg";